import script from "./personInfo.vue?vue&type=script&setup=true&name=PersonInfo&lang=js"
export * from "./personInfo.vue?vue&type=script&setup=true&name=PersonInfo&lang=js"

import "./personInfo.vue?vue&type=style&index=0&id=f6160c60&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6160c60"]])

export default __exports__